// extracted by mini-css-extract-plugin
export default {"Title":"Support_Title__cCDxO","Text":"Support_Text__XrQkW"};